import { render, staticRenderFns } from "./AVM.vue?vue&type=template&id=84a34baa&scoped=true&"
import script from "./AVM.vue?vue&type=script&lang=js&"
export * from "./AVM.vue?vue&type=script&lang=js&"
import style0 from "./AVM.vue?vue&type=style&index=0&id=84a34baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a34baa",
  null
  
)

/* custom blocks */
import block0 from "./AVM.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports